angular.module('mercury.modules.time.clock')
.factory('PayRuleConstant', function() {
  return {
    RuleType: {
      Add: 'Add',
      Subtract: 'Subtract',
      Equals: 'Equals',
      Multiple: 'Multiple',
      PercentageTotal: 'PercentageTotal'
    },
    OverrideType: {
      Add: 'Add',
      Deactivate: 'Deactivate',
      TimeAdjustment: 'TimeAdjustment'
    },
    RuleSource: {
      Managed: 'Managed',
      Custom: 'Custom',
      UserDefined: 'UserDefined',
      Override: 'Override'
    },
    RuleTypeIcon: {
      Override: 'fa fa-user',
      Managed: 'fa fa-shield',
      Custom: 'fa fa-building',
      UserDefined: 'fa fa-building'
    },
    RuleTypeIconTooltip: {
      Override: 'Override',
      Managed: 'Managed',
      Custom: 'Custom',
      UserDefined: 'Custom'
    },
    PackageType: {
      Managed: 'Managed',
      Custom: 'Custom',
      UserDefined: 'UserDefined'
    },
    PackageTypeIcon: {
      Managed: 'fa fa-shield',
      Custom: 'fa fa-building'
    },
    PackageTypeIconToolip: {
      Managed: 'Managed',
      Custom: 'Custom'
    },
    ApplyType: {
      All: 'All',
      Any: 'Any'
    },
    TimePeriodTooltip: {
      Managed: 'Time periods of managed adjustments can not be edited. Please delete and add as a manual adjustment to edit',
      Custom: 'Time periods of custom adjustments can not be edited here.',
      Override: '',
      UserDefined: 'Time periods of custom adjustments can not be edited here. Please delete and add as a manual adjustment to edit'
    }
  };
});
